import { render, staticRenderFns } from "./CloudProviderTypeIcon.vue?vue&type=template&id=37a0deab&"
import script from "./CloudProviderTypeIcon.vue?vue&type=script&lang=js&"
export * from "./CloudProviderTypeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports